
export const MY_SETTING_SET_AVATOR = 'MY_SETTING_SET_AVATOR';


// WEBPACK FOOTER //
// ./src/views/MySetting/flow/actionType.js